// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20wX4","controls":"styles_controls__4_DYK","charLimit":"styles_charLimit__2gAoU","input":"styles_input__1QWbD","send":"styles_send__2MyxZ"};